<!-- TODO: waiting for Branos designs -->

<div class="v-h-centered app-version-container">
  <div class="text-center px-5">
    <div>
      <img class="max-w-100" src="assets/images/house-pan.png" alt="" />
    </div>
    <div class="pb-3 bold text-28">This App Version Is a Bit... Toasty</div>
    <br />
    <div class="pb-3">
      Still using the old one? It's like leaving a house on a hot pan — not ideal.
    </div>
    <div class="pb-5">
      <strong>Update now</strong> on the App Store  or Google Play before things  really heat up.
    </div>
    <br />
    <div>
      <button pButton class="p-button p-button-primary m-a centered" (click)="gotToStore()">
        Tap here to update now.
      </button>
    </div>
  </div>
</div>
